import { createTheme } from "@mui/material/styles";

export const pointGenieThemeTokens = {
  light: {
    primary: "#2563EB",
    accent: "#2F7CF6",
    onAccent: "#FFFFFF",
    bg: "#F8FAFC",
    bgStart: "#F8FAFC",
    bgEnd: "#EEF2F7",
    card: "#FFFFFF",
    surfaceMuted: "#F1F5F9",
    cardHover: "#F1F5F9",
    text: "#0B1220",
    text2: "#1E293B",
    text3: "#475569",
    textMuted: "#475569",
    textDim: "#64748B",
    border: "rgba(15,23,42,0.08)",
    success: "#16A34A",
    successMuted: "rgba(22,163,74,0.12)",
    danger: "#DC2626",
    accentBlue: "#2563EB",
    accentBlueBg: "rgba(37,99,235,0.12)",
    accentBlueBorder: "rgba(37,99,235,0.12)",
  },
  dark: {
    primary: "#3B82F6",
    accent: "#2F7CF6",
    onAccent: "#FFFFFF",
    bg: "#0B0F1A",
    bgStart: "#0F172A",
    bgEnd: "#020617",
    card: "#1E293B",
    surfaceMuted: "#111827",
    cardHover: "#334155",
    text: "#FFFFFF",
    text2: "#E2E8F0",
    text3: "#94A3B8",
    textMuted: "#9CA3AF",
    textDim: "#6B7280",
    border: "rgba(255,255,255,0.06)",
    success: "#3DDC97",
    successMuted: "rgba(61,220,151,0.15)",
    danger: "#FF6B6B",
    accentBlue: "#60A5FA",
    accentBlueBg: "rgba(59,130,246,0.10)",
    accentBlueBorder: "rgba(59,130,246,0.10)",
  },
};

export function createPointGenieTheme(mode) {
  const c = pointGenieThemeTokens[mode] || pointGenieThemeTokens.dark;

  return createTheme({
    palette: {
      mode,
      primary: {
        main: c.accent,
        contrastText: c.onAccent,
      },
      success: {
        main: c.success,
      },
      error: {
        main: c.danger,
      },
      background: {
        default: c.bg,
        paper: c.card,
      },
      text: {
        primary: c.text,
        secondary: c.textMuted,
      },
      divider: c.border,
      pointGenie: c,
    },
    typography: {
      fontFamily: "Goldplay, Roboto, Arial, sans-serif",
      button: {
        textTransform: "none",
      },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: c.bg,
            color: c.text,
            transition: "background-color 160ms ease, color 160ms ease",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundImage: "none",
          },
        },
      },
      MuiTextField: {
        defaultProps: {
          variant: "outlined",
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            backgroundColor: c.card,
            color: c.text,
            "& fieldset": {
              borderColor: c.border,
            },
            "&:hover fieldset": {
              borderColor: c.accentBlue,
            },
            "&.Mui-focused fieldset": {
              borderColor: c.accent,
            },
          },
          input: {
            color: c.text,
            "&::placeholder": {
              color: c.textMuted,
              opacity: 1,
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: c.textMuted,
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: c.card,
            color: c.text,
            border: `1px solid ${c.border}`,
          },
        },
      },
      MuiModal: {
        styleOverrides: {
          root: {
            color: c.text,
          },
        },
      },
    },
  });
}
